import { Component, ChangeDetectionStrategy } from '@angular/core';

@Component({
    selector: 'app-workflow-content-skeleton',
    imports: [],
    changeDetection: ChangeDetectionStrategy.OnPush,
    templateUrl: './workflow-content-skeleton.component.html'
})
export class WorkflowContentSkeletonComponent {}
